__webpack_require__.p = "/type-app/";